import useIdentity from "@/features/ui/hooks/use-identity";
import BuyerOrderSheetSetListPage from "@/features/order-status/buyer-order-sheet-set-list-page";
import AgencyOrderSheetSetListPage from "@/features/order-status/agency-order-sheet-set-list-page";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import BoutiqueOrderSheetSetListPage from "@/features/order-status/boutique-order-sheet-set-list-page";
import { getCanonicalUrl } from "@/shared/utils/canonical-url";

export default function OrderSheetSetListPage() {
  const identity = useIdentity();
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Pathrade | {t("order_sheets")}</title>
        <link
          rel="canonical"
          href={getCanonicalUrl()}
        />
        <meta property="og:title" content={`Pathrade | ${t("order_sheets")}`} />
        <meta
          property="og:url"
          content={getCanonicalUrl()}
        />
      </Helmet>
      {identity?.company?.type === "AGENCY" ? (
        <AgencyOrderSheetSetListPage />
      ) : identity?.company?.type === "BUYER" ? (
        <BuyerOrderSheetSetListPage />
      )  : identity?.company?.type === "BOUTIQUE" ? (
        <BoutiqueOrderSheetSetListPage />
      ) : (
        <></>
      )}
    </>
  );
}
